// extracted by mini-css-extract-plugin
module.exports = {"flex-row":"_4e5f713ae4--flex-row--Q_ljh"};